import {FC} from 'react'
import {useQuery} from 'react-query'
import {isNotEmpty, QUERIES} from '../../../helpers'
import {ContractsModalContent} from './ContractsModalContent'
import {ID} from '../../../helpers'
import {getContractById} from '../../../../app/modules/contracts/components/contracts-list/core/_requests'

type Props = {
  id: ID
  projectId: string | undefined
  clientId: string | undefined
  handleClose: () => void | undefined
}

const emptyContractResponse = {
  contracts: {id: undefined},
  message: '',
  errors: false,
}

const ContractsModalContentWrapper: FC<Props> = ({id, handleClose, projectId, clientId}) => {
  const enabledQuery = isNotEmpty(id)
  const {isLoading, data: contract, error} = useQuery(
    `${QUERIES.CONTRACTS_LIST}-CONTRACT-${id ?? 'new'}`,
    () => getContractById(id),
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        console.error(err)
      },
      refetchOnWindowFocus: false,
    }
  )

  if (!enabledQuery) {
    return (
      <ContractsModalContent
        key='contract-new'
        handleClose={handleClose}
        projectId={projectId}
        clientId={clientId}
        isContractLoading={false}
        Contracts={emptyContractResponse}
      />
    )
  }

  if (!isLoading && !error && contract) {
    return (
      <ContractsModalContent
        key={`contract-edit-${id}`}
        handleClose={handleClose}
        projectId={projectId}
        clientId={clientId}
        isContractLoading={isLoading}
        Contracts={contract}
      />
    )
  }

  return null
}

export {ContractsModalContentWrapper}